var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-mask",attrs:{"transition":"modal"},on:{"click":_vm.hide}},[_c('div',{staticClass:"video-modal-wrapper"},[_c('div',{staticClass:"video-modal-container modal-transition-container"},[_vm._t("loading"),_vm._v(" "),_vm._t("body")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }